import Modal from '@resources/js/ui/Modal';
const headerMenuElement = document.querySelector('.js-menu');
if (headerMenuElement) {
    new Modal(headerMenuElement, {
        trigger: '.js-menu-open-btn',
        selectors: {
            close: '.js-menu-close-btn',
        },
    });
}
